<div class="modal-header">
  <h4 class="modal-title"
      [translate]="dumpster ? 'services.waste.modal.modifyTitle' : 'services.waste.modal.addTitle'">
  </h4>

  <button class="btn-close" aria-label="Close"
          (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form name="dumpsterForm" [formGroup]="dumpsterForm">

    <div class="row">

      <!-- deviceId -->
      <div class="col-12">
        <label class="form-label" for="deviceId">{{ 'services.waste.modal.deviceId' | translate }}*</label>
        <input class="form-control" id="deviceId" type="text" name="deviceId" maxlength="50"
               [formControl]="deviceId"
               pattern="{{ FormUtils.textInputPattern }}"
               placeholder="{{ 'services.waste.modal.deviceId' | translate }}"
               required>
        <app-form-error [control]="deviceId"></app-form-error>
      </div>

      <!-- Name -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="nameFR">{{ 'services.waste.modal.nameFR' | translate }}*</label>
        <input class="form-control" id="nameFR" type="text" name="nameFR" maxlength="50"
               [formControl]="nameFR"
               pattern="{{ FormUtils.textInputPattern }}"
               placeholder="{{ 'services.waste.modal.nameFR' | translate }}"
               required>
        <app-form-error [control]="nameFR"></app-form-error>
      </div>

      @if (customerConfigService.isLanguageAvailable('de')) {
        <div class="col-12 col-md-6">
          <label class="form-label" for="nameDE">{{ 'services.waste.modal.nameDE' | translate }}</label>
          <input class="form-control" id="nameDE" type="text" name="nameDE" maxlength="50"
                 [formControl]="nameDE"
                 pattern="{{ FormUtils.textInputPattern }}"
                 placeholder="{{ 'services.waste.modal.nameDE' | translate }}">
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('it')) {
        <div class="col-12 col-md-6">
          <label class="form-label" for="nameIT">{{ 'services.waste.modal.nameIT' | translate }}</label>
          <input class="form-control" id="nameIT" type="text" name="nameIT" maxlength="50"
                 [formControl]="nameIT"
                 pattern="{{ FormUtils.textInputPattern }}"
                 placeholder="{{ 'services.waste.modal.nameIT' | translate }}">
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('en')) {
        <div class="col-12 col-md-6">
          <label class="form-label" for="nameEN">{{ 'services.waste.modal.nameEN' | translate }}</label>
          <input class="form-control" id="nameEN" type="text" name="nameEN" maxlength="50"
                 [formControl]="nameEN"
                 pattern="{{ FormUtils.textInputPattern }}"
                 placeholder="{{ 'services.waste.modal.nameEN' | translate }}">
        </div>
      }

      <!-- Description -->
      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'services.waste.modal.descriptionFR' | translate }}</label>
        <textarea class="form-control" id="descriptionFR"
                  placeholder="{{ 'services.waste.modal.descriptionFR' | translate }}"
                  maxLength="100" rows="3"
                  [formControl]="descriptionFR"
                  pattern="{{ FormUtils.textInputPattern }}"></textarea>
      </div>

      @if (customerConfigService.isLanguageAvailable('de')) {
        <div class="col-12 col-md-6">
          <label class="form-label">{{ 'services.waste.modal.descriptionDE' | translate }}</label>
          <textarea class="form-control" id="descriptionDE"
                    placeholder="{{ 'services.waste.modal.descriptionDE' | translate }}"
                    maxLength="100" rows="3"
                    [formControl]="descriptionDE"
                    pattern="{{ FormUtils.textInputPattern }}"></textarea>
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('it')) {
        <div class="col-12 col-md-6">
          <label class="form-label">{{ 'services.waste.modal.descriptionIT' | translate }}</label>
          <textarea class="form-control" id="descriptionIT"
                    placeholder="{{ 'services.waste.modal.descriptionIT' | translate }}"
                    maxLength="100" rows="3"
                    [formControl]="descriptionIT"
                    pattern="{{ FormUtils.textInputPattern }}"></textarea>
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('en')) {
        <div class="col-12 col-md-6">
          <label class="form-label">{{ 'services.waste.modal.descriptionEN' | translate }}</label>
          <textarea class="form-control" id="descriptionEN"
                    placeholder="{{ 'services.waste.modal.descriptionEN' | translate }}"
                    maxLength="100" rows="3"
                    [formControl]="descriptionEN"
                    pattern="{{ FormUtils.textInputPattern }}"></textarea>
        </div>
      }

      <div class="col-12 col-md-6">
        <label class="form-label" for="tenantCode">{{ 'services.waste.modal.tenant' | translate }}*</label>
        <select class="form-control form-select" id="tenantCode" name="tenantCode"
                [formControl]="tenantCode">
          @for (tenant of tenantCodes; track tenant) {
            <option
              [ngValue]="tenant.code">{{ tenant.label }} - {{ tenant.code }}
            </option>
          }
        </select>
        <app-form-error [control]="tenantCode"></app-form-error>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label" for="dumpsterProvider">{{ 'services.waste.modal.type' | translate }}*</label>
        <select class="form-control form-select" id="dumpsterProvider" name="dumpsterProvider"
                [formControl]="dumpsterProvider">
          @for (provider of dumpsterProviders; track provider) {
            <option
              [ngValue]="provider.value">{{ provider.label }}
            </option>
          }
        </select>
        <app-form-error [control]="dumpsterProvider"></app-form-error>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-secondary"
          (click)="activeModal.close()"
          translate="common.cancel">
  </button>
  <button class="btn btn-primary" type="submit"
          [disabled]="dumpsterForm.invalid"
          (click)="addOrUpdateDumpster()"
          translate="common.save">
  </button>
</div>
